export class DtmPageInfo {
  pageName: string;
  URL: string;
  siteSection: string;
  subSection: string;
  tipoDeCanal: string;

  constructor(pageInfoData) {
    this.pageName = pageInfoData.pageName;
    this.URL = pageInfoData.url;
    this.siteSection = pageInfoData.siteSection;
    this.subSection = pageInfoData.subSection;
    this.tipoDeCanal = pageInfoData.tipoDeCanal;
  }
}
